import { MTableEditField } from '@material-table/core';
import { lcsInternalExposureLookup, lcsNames, M_ID } from 'utils/constants/lcsTypes';
import React from 'react';

export default (user, flowsLookup) => {
  const columns = [
    {
      title: 'Código',
      field: 'codigo',
      minWidth: 150,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Fluxograma',
      field: 'id_fluxograma',
      lookup: flowsLookup,
      initialEditValue: Object.keys(flowsLookup)[0],
      minWidth: 400,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editable: 'onAdd',
      editComponent: (props) => <MTableEditField fullWidth {...props}/>,
    },
    {
      title: 'LCS',
      field: 'id_lcs',
      minWidth: 200,
      initialEditValue: M_ID,
      lookup: lcsInternalExposureLookup,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editable: 'onAdd',
      render: rowData => rowData.id_lcs !== '' ? lcsInternalExposureLookup[rowData.id_lcs] : '',
    },
    {
      title: 'Designação',
      field: 'designacao',
      minWidth: 200,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Notas',
      field: 'notas',
      minWidth: 200,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ]

  return user.is_staff ? columnsAdmin : columns;
};
